import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { hasEnabledFeature } from 'globalutils/fmUtils';
import useAccordionList from './AccordionList/useAccordionList';
import Accordion from 'globalcomponents/Accordion';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));

const Component = ({ history, Styled, expandedNotNeeded, ...rest }) => {
  const { i18n } = useTranslation();

  const { accordionListArray } = useAccordionList({
    i18n,
    history,
    Styled,
    ...rest,
  });

  return (
    <Styled.Wrapper>
      {hasEnabledFeature('downloadCenterEnabled') ? (
        <div className="manageSchedulingWrapper">
          <Button
            type="submit"
            label={i18n.t('Manage Scheduling')}
            onClick={() => {
              history.push('/scheduling/list');
            }}
          />
        </div>
      ) : null}
      <Accordion
        data={
          window.$environment.CURRENT_LAYOUT === 'OldUi' || expandedNotNeeded
            ? accordionListArray.map((item) => {
                item.defaultExpanded = true;
                item.disabled = true;
                return item;
              })
            : accordionListArray
        }
        className="accordionWrapper"
      ></Accordion>
    </Styled.Wrapper>
  );
};

export default Component;

Component.defaultProps = {
  drivers: {},
  regions: {},
};

Component.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  dutyStatusReport: PropTypes.func.isRequired,
  driverPerformanceReport: PropTypes.func.isRequired,
  editedDataReport: PropTypes.func.isRequired,
  drivingEventReport: PropTypes.func.isRequired,
  eldDisconnectReport: PropTypes.func.isRequired,
  odometerJumpReport: PropTypes.func.isRequired,
  malfunctionReport: PropTypes.func.isRequired,
  unassignedDrivingReport: PropTypes.func.isRequired,
  violationReport: PropTypes.func.isRequired,
  downloadReport: PropTypes.func.isRequired,
  hosViolationsReport: PropTypes.func.isRequired,
  rejectedEditsReport: PropTypes.func.isRequired,
  drivers: PropTypes.object,
  regions: PropTypes.object,
  fetchTerminals: PropTypes.func.isRequired,
  fetchDepartments: PropTypes.func.isRequired,
};
